export default "__VITE_ASSET__76fb915f__"